import { observable } from 'mobx';

export interface BusinessEkinetAccountArgs {
  id: number;
  organization_id: number;
  business_ekinet_id: string;
  password: string;
  users?: User[];
}

export interface User {
  name: string;
  email: string;
}

export class BusinessEkinetAccount {
  @observable id: number;

  @observable organizationId: number;

  @observable businessEkinetId: string;

  @observable password: string;

  @observable users: User[];

  constructor(args: Partial<BusinessEkinetAccountArgs> = {}) {
    this.id = args.id || 0;
    this.organizationId = args.organization_id || 0;
    this.businessEkinetId = args.business_ekinet_id || '';
    this.password = args.password || '';
    this.users = args.users || [];
  }

  submitParams() {
    return {
      id: this.id,
      organization_id: this.organizationId,
      business_ekinet_id: this.businessEkinetId,
      password: this.password
    };
  }

  setBusinessEkinetId(data: string) {
    this.businessEkinetId = data;
    app.render();
  }

  setPassword(data: string) {
    this.password = data;
    app.render();
  }
}

export default BusinessEkinetAccount;
